import * as React from 'react';
import VariantAttributes from '../../components/forms/VariantAttributes';
import Section from '../../components/Section';
import { Variant, Attribute } from '../../product';
import HelpHint from '../../components/HelpHint';

type Props = {
  variant: Variant;
  setVariant: Function;
};

const setValue = (obj: Variant, onChange: Function) => (
  field: string,
  newValue: any,
) =>
  onChange(
    Object.assign({}, obj, {
      [field]: newValue,
    }),
  );

const grindSizeAttributes: Attribute[] = [
  { name: 'Grind Size', options: ['Whole Bean', 'Filter Coffee', 'Espresso'] },
];

const giftWrappingAttributes: Attribute[] = [
  { name: 'Gift Wrapping', options: ['No Gift Wrapping', 'Gift Wrapped'] },
];

const clothingSizeAttributes: Attribute[] = [
  { name: 'Size', options: ['XS', 'S', 'M', 'L', 'XL', '2XL'] },
];

export default function VariantAttributesInfo(props: Props) {
  const handleOnChange = setValue(props.variant, props.setVariant);
  const append = (presets: Attribute[]) =>
    handleOnChange('attributes', props.variant.attributes.concat(presets));

  return (
    <Section title="Attributes">
      <div className="flex flex-wrap">
        <div className="flex-auto w-70-ns w-100 pr2">
          <VariantAttributes
            field={['attributes']}
            label=""
            defaultValue={props.variant.attributes}
            onValueChange={handleOnChange}
          />
        </div>
        <div className="flex-auto w-30-ns w-100 pl2">
          <HelpHint>
            Attributes let customers to choose a specific configuration of the
            product. For example, you may wish to offer pre-ground option if
            selling coffee beans.
            <br />
            <br />
            You can also use one of the presets below:
          </HelpHint>
          <div className="flex flex-column">
            <button
              className="tl f5 link dim br-pill bg-white-10 ph3 pv2 mb2 gold bw0 pointer"
              onClick={() => append(grindSizeAttributes)}
              type="button"
            >
              Grind Size/Whole Bean
            </button>
            <button
              className="tl f5 link dim br-pill bg-white-10 ph3 pv2 mb2 gold bw0 pointer"
              onClick={() => append(giftWrappingAttributes)}
              type="button"
            >
              Gift Wrapping
            </button>
            <button
              className="tl f5 link dim br-pill bg-white-10 ph3 pv2 mb2 gold bw0 pointer"
              onClick={() => append(clothingSizeAttributes)}
              type="button"
            >
              Clothing Size
            </button>
          </div>
        </div>
      </div>
    </Section>
  );
}
